import {SelectableAccessoryModel, selectableAccessoryModelListFactory} from "../../asset/selectable-accessory.model";

export interface DefectAssetBundleModel {
  id?: string;
  deviceKey?: string;
  product?: string;
  productDescription?: string;
  productNumber?: string;
  serialNumber?: string;
  accessories?: SelectableAccessoryModel[];
  standaloneAccessories?: SelectableAccessoryModel[];
  reorderFullBundle?: boolean;
}

export function defectAssetBundleModelFactory(json?: any): DefectAssetBundleModel {
  json = json || {};

  return {
    id: json.id || "",
    deviceKey: json.deviceKey || "",
    product: json.product || "",
    productDescription: json.productDescription || "",
    productNumber: json.productNumber || "",
    serialNumber: json.serialNumber || "",
    accessories: selectableAccessoryModelListFactory(json.accessories),
    standaloneAccessories: selectableAccessoryModelListFactory(json.standaloneAccessories),
    reorderFullBundle: !!json.reorderFullBundle,
  } as DefectAssetBundleModel;
}

export function defectAssetBundleModelListFactory(json?: any): DefectAssetBundleModel[] {
  return Array.from(json || []).map(it => defectAssetBundleModelFactory(it)) as DefectAssetBundleModel[];
}
